import { render, staticRenderFns } from "./MdText.vue?vue&type=template&id=ef6cf32e&"
import script from "./MdText.vue?vue&type=script&lang=js&"
export * from "./MdText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports